<template>
  <div class="cart-item">
    <ul class="cart-item__list">
      <li v-for="(item, name) in itemsSort" :key="item.id" class="cart-item__item">
        <template v-if="item">
          <span
            class="cart-item__link cart-item__inner"
            :class="[$route.params.order === item.page.order ? 'is-exact-active' : '']"
            v-if="Number(item.page.order) <= 2"
            @click="warningDialog(item)">
            <span class="cart-item__title">{{ item.list.name | uppercase }}</span>
            <span class="cart-item__name">{{ item.name | uppercase }} </span>
            <span v-if="item.priceIncTax" class="cart-item__price">{{ item.priceIncTax | price }}円</span>
          </span>
          <router-link
            class="cart-item__link cart-item__inner"
            v-else
            :to="{
              path: [$route.path.match(/gogatsu/) ?  config.path.root_gogatsu : config.path.root] + '/step/' + item.page.slug + '/' + item.page.order,
              query: $route.query,
            }"
            exact>
            <span class="cart-item__title">{{ item.list.name | uppercase }}</span>
            <span class="cart-item__name">{{ item.name | uppercase }}</span>
            <span v-if="item.priceIncTax" class="cart-item__price">{{ item.priceIncTax | price }}円</span>
          </router-link>
        </template>
      </li>
    </ul>

    <v-prev-dialog v-model="dialog.state" message="サイズ、人数へ戻ると今まで選択した商品がリセットされます。"/>
  </div>
</template>



<script>
import { mapState } from 'vuex'

export default {
  components: {
    'v-prev-dialog': require('@/components/prev-dialog.vue').default,
  },
  computed: {
    ...mapState({
      prevPage: state => state.step.prev,
      stateCartItems: state => state.cart.items,
    }),
    itemsSort() {
      let val = JSON.parse(JSON.stringify(this.stateCartItems))
      let sorted = {}
      let array = []

      Object.keys(val).forEach((key) => {
        if (val.hasOwnProperty(key)) {
          array.push(key)
        }
      })

      array.sort((a, b) => {
        a = Number(val[a].page.order.replace('-', '.'))
        b = Number(val[b].page.order.replace('-', '.'))

        if (a < b){
          return -1
        } else if (a > b){
          return 1
        }
        return 0
      })

      for (let i=0; i<array.length; i++) {
        sorted[array[i]] = this.stateCartItems[array[i]]
      }

      return sorted
    },
  },
  data() {
    return {
      dialog: {
        state: false,
      }
    }
  },
  methods: {
    warningDialog(item) {
      if (Number(this.$route.params.order) === Number(item.page.order)) {
        return
      } else if (Number(this.$route.params.order) < 3) {
        this.$router.push({
          path: this.config.path.root + '/step/sizes/1',
          query: '',
        })
      } else {
        this.$set(this.dialog, 'state', true)
      }
    },
    pageDataReset() {
      this.$router.push({
        path: this.config.path.root + '/step/sizes/1',
        query: '',
      })

      this.dialog.state = false
    },
  },
  filters: {
    uppercase(val) {
      if (!val) return

      val = String(val)

      return val.replace(/[a-zA-Z0-9,]/g, (str) => {
        return String.fromCharCode(str.charCodeAt(0) + 65248).toLocaleString()
      })
    },
    price(val) {
      if (!val) return

      val = String(val)
      val = val.replace(/,/g, '')
      val = Number(val)
      val = val.toLocaleString()
      val = val.toString()

      return val.replace(/[0-9,]/g, (str) => {
        return String.fromCharCode(str.charCodeAt(0) + 65248).toLocaleString()
      })
    },
  },
}
</script>



<style lang="scss">
.cart-item {
  $e: &;
  &__list {
    display: flex;
    justify-content: center;
    font-family: $serif;
    font-size: 12px;
  }
  &__item {
  }
  &__inner {
    cursor: pointer;
    display: block;
    position: relative;
    border-radius: 3px;
    text-align: center;
    width: 30px;
    padding-top: 16px;
    padding-bottom: 16px;
  }
  &__link {
    color: $oc-gray-9;
    height: 100%;
    &:hover {
      background-color: #f1f3f5;
    }
    &.router-link-exact-active,
    &.is-exact-active {
      cursor: default;
      background-color: transparent;
      &::before {
        content: "";
        position: absolute;
        top: -10px;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 50%;
        background: url(/choice/img/icon/plum.svg) center center / 14px 14px no-repeat;
        width: 14px;
        height: 14px;
      }
    }
  }
  &__title {
    font-weight: bold;
    text-align: justify-all;
    text-align-last: justify;
    text-justify: inter-ideograph;
    writing-mode: vertical-rl;
    height: 100px;
  }
  &__name {
    position: relative;
    text-align: left;
    writing-mode: vertical-rl;
    min-height: 256px;
    max-height: calc(100vh - 284px);
    padding-top: 56px;
    padding-bottom: 128px;
    &::before {
      content: "";
      position: absolute;
      top: 16px;
      left: 50%;
      transform: translateX(-1px);
      z-index: 1;
      border-left: 2px dotted $oc-gray-4;
      width: 0;
      height: 24px;
    }
  }
  &__price {
    display: block;
    writing-mode: vertical-lr;
    position: absolute;
    left: 50%;
    bottom: 16px;
    transform: translateX(-50%);
    font-size: 11px;
  }

  &__button {
    $e: &;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    display: inline-block;
    appearance: none;
    transition: $transition;
    outline: none;
    border: none;
    background: transparent;
    font-size: 12px;
    text-align: center;
    color: $oc-gray-8;
    &:disabled {
      cursor: no-drop;
    }
    &--primary,
    &--cancel {
      border-radius: 999px;
      width: 176px;
      padding-top: 16px;
      padding-bottom: 16px;
    }
    &--primary {
      border: 1px solid $accent-color;
      background-color: $accent-color;
      color: #fff;
      @include hover() {
        border-color: $accent-color-hover;
        background-color: $accent-color-hover;
      }
      @include active() {
        border-color: $accent-color-active;
        background-color: $accent-color-active;
        color: #fff;
      }
    }
    &--cancel {
      border: 1px solid $oc-gray-4;
      margin-left: 16px;
      @include hover() {
        border-color: $accent-color;
        color: $accent-color;
      }
      @include active() {
        border-color: $accent-color;
        background-color: $accent-color-bg;
        color: $accent-color;
      }
    }
  }

  &__dialog {
    border-radius: 8px;
    text-align: center;
    width: 90%;
    @include breakpoints-min(sm) {
      width: 80%;
    }
    @include breakpoints-min(md) {
      width: 65%;
    }
    @include breakpoints-min(lg) {
      width: 512px;
    }
  }
  &__dialog-action {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }
}

.app-gogatsu {
    .cart-item {
        &__link {
            &.router-link-exact-active,
            &.is-exact-active {
                &::before {
                    background: url(/choice/img/icon/plum-gogatsu.svg) center center / 14px 14px no-repeat;
                }
            }
        }

        &__button {
            &--primary {
                border-color: $gogatsu-accent-color;
                background-color: $gogatsu-accent-color;
                color: #fff;
                @include hover() {
                    border-color: $gogatsu-accent-color-hover;
                    background-color: $gogatsu-accent-color-hover;
                }
                @include active() {
                    border-color: $gogatsu-accent-color-active;
                    background-color: $gogatsu-accent-color-active;
                    color: #fff;
                }
            }
            &--cancel {
                border: 1px solid $oc-gray-4;
                margin-left: 16px;
                @include hover() {
                    border-color: $gogatsu-accent-color;
                    color: $gogatsu-accent-color;
                }
                @include active() {
                    border-color: $gogatsu-accent-color;
                    background-color: $gogatsu-accent-color-bg;
                    color: $gogatsu-accent-color;
                }
            }
        }

    }
}
</style>
